export const GET_WARRANTY_REQUEST="GET_WARRANTY_REQUEST"
export const GET_WARRANTY_SUCCESS="GET_WARRANTY_SUCCESS"
export const GET_WARRANTY_FAILURE="GET_WARRANTY_FAILURE"